/**
 * OMV (installateur CEE) — logique pure, testable hors React.
 *
 * Extrait de HubGrid.jsx / CreateDossier.jsx pour non-régression unitaire.
 * Cf. AUDIT source réelle numero_dossier 2026-06-12 : on a cessé d'alimenter
 * numero_dossier (réservé au n° de série MANUEL de Solène) avec le n° du
 * formulaire CEE délégataire lu par Vision.
 *
 * Field-names spec SPEC-CEE-OMV-DOSSIER-2026-06-07 (schéma models.py).
 * Émis par hub_grids.py uniquement pour le tenant omv_france.
 */

// Colonnes de la grille dossiers OMV. La 1re colonne "N° dossier" affiche la
// RÉFÉRENCE auto (dossier.reference) — PAS numero_dossier (manuel, souvent vide
// et anciennement pollué par la valeur Vision). NE concerne QUE omv_france ;
// TEF/climat gardent HUB_COLUMNS.
export const OMV_DOSSIER_COLUMNS = [
  { key: "reference", label: "N° dossier", mono: true, sortable: true },
  // D6 #1 — bénéficiaire (raison sociale entreprise B2B), libellé explicite "Bénéficiaire".
  { key: "raison_sociale", label: "Bénéficiaire", sortable: true },
  // D6 #2 — établissement = site des travaux (batiment.nom_etablissement), distinct du bénéficiaire.
  { key: "nom_etablissement", label: "Établissement", sortable: true },
  // D6 #3 — CP + VILLE des TRAVAUX (champs structurés cp_travaux/ville_travaux qui
  // pilotent la zone climatique). JAMAIS le siège bénéficiaire. Cf. hub_grids.py.
  { key: "cp_travaux", label: "CP", muted: true, sortable: true },
  { key: "ville_travaux", label: "Ville", sortable: true },
  { key: "surface_ventilee_m2", label: "Surface (m²)", sortable: true },
  { key: "type_vmc", label: "Type VMC", vmc: true, sortable: true },
  { key: "nb_caissons", label: "Nb caissons", sortable: true },
  { key: "statut", label: "Statut", badge: true, sortable: true },
];

/**
 * Range le n° lu par Vision sur le formulaire CEE (numero_dossier_detecte) dans
 * `cee.reference_formulaire` — champ NON-identifiant, proposition seulement.
 * NE touche JAMAIS numero_dossier. N'écrase pas une valeur déjà saisie.
 *
 * @param {object} cee  bloc CEE courant (omv.cee)
 * @param {*} detected  valeur brute renvoyée par l'extraction Vision
 * @returns {object} nouveau bloc cee (copie)
 */
export function applyDetectedFormRef(cee, detected) {
  const out = { ...(cee || {}) };
  const hasDetected =
    detected !== null && detected !== undefined && String(detected) !== "";
  if (hasDetected && !out.reference_formulaire) {
    out.reference_formulaire = String(detected);
  }
  return out;
}
